// export const BASE_URL = `${window.location.protocol}//${window.location.hostname}/Project/StarComputer/backend`;
// const hostname = window.location.hostname;

// export const BASE_URL =
//   hostname === "localhost" ||
//   hostname === "192.168.1.100" ||
//   hostname === "192.168.1.103"
//     ? `${window.location.protocol}//${hostname}/StarComputer/backend`
//     : "https://tallyworkshop.co.in/backend";

export const BASE_URL = "https://tallyworkshop.co.in/backend";
